import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useLocation, useRoutes } from "react-router-dom";
import { Fragment, createElement, useEffect } from "react";
import PageSeo from "../seo/PageSeo";
import i18n from "../i18n";
import { localeFromPath } from "../lib/locale";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();
  // Switch synchronously so the same render pass already reads the right translations
  // (resources are bundled, so changeLanguage completes without loading).
  const locale = localeFromPath(pathname);
  if (i18n.resolvedLanguage !== locale) i18n.changeLanguage(locale);
  const element = useRoutes(routes);
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  useEffect(() => {
    const target = hash ? document.getElementById(hash.slice(1)) : null;
    if (target) target.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return createElement(Fragment, null,
    createElement(PageSeo),
    element,
  );
}
